/* Nutty - most izmedju starih Nutty skripti i Horizonovog cart drawera
   (10.9.2026, uz gasenje Snap Cart Drawer appa)

   MORA se ucitati PRVI, prije nutty-pretplata.js - taj pri pokretanju uzme
   referencu na window.fetch, pa nas mora zateci vec postavljene.

   Radi tri stvari, sve bez diranja starih skripti:

   1. Oznaci svaku liniju pretplatnickog paketa s '_paket_handle' i '_kom'
      (koliko komada te barice ide u jedan paket). Bez toga Liquid u draweru
      ne moze znati koliko je paketa u kosarici, jer paket u kosarici nije
      jedna linija nego 12+ komponenti. Podaci se citaju iz NuttyPack.map,
      pa ostaje jedan izvor istine - tablica PACKS u nutty-pretplata.js.

   2. Presretne 'cart:update' bez detalja. Stare skripte ga salju kao goli
      CustomEvent; Horizonove komponente citaju event.detail.data i pukle bi.
      Umjesto njega saljemo ispravan event, na koji se drawer sam osvjezi.

   3. Horizonovom gumbu za kosaricu doda data-cart-drawer-toggle. Stare
      skripte drawer otvaraju klikom na tim selektorom; bez ovoga bi kliknule
      obican link na /cart i odvele kupca sa stranice. */
(function () {
  'use strict';

  var nativeFetch = window.fetch.bind(window);
  var nativeDispatch = document.dispatchEvent.bind(document);
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var PROP = 'Paket';

  /* ---------- 1. oznacavanje linija paketa ---------- */

  function decorate(items) {
    var map = window.NuttyPack && window.NuttyPack.map;
    if (!map || !items || !items.length) return false;
    var touched = false;

    items.forEach(function (line) {
      var props = line.properties;
      if (!props || !props[PROP] || props._kom) return;

      Object.keys(map).forEach(function (handle) {
        if (map[handle].title !== props[PROP]) return;
        var per = 0;
        map[handle].items.forEach(function (entry) {
          if (entry[0] === line.id) per = entry[1];
        });
        if (!per) return;
        var copy = {};
        Object.keys(props).forEach(function (k) { copy[k] = props[k]; });
        copy._paket_handle = handle;
        copy._kom = String(per);
        line.properties = copy;
        touched = true;
      });
    });

    return touched;
  }

  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();

      if (method === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url) && init && typeof init.body === 'string') {
        var data = JSON.parse(init.body);
        if (decorate(data && data.items)) {
          var next = {};
          Object.keys(init).forEach(function (k) { next[k] = init[k]; });
          next.body = JSON.stringify(data);
          return nativeFetch(input, next);
        }
      }
    } catch (e) {}

    return nativeFetch(input, init);
  };

  /* ---------- 2. ispravan cart:update ---------- */

  function properCartUpdate(itemCount) {
    var e = new Event('cart:update', { bubbles: true });
    e.detail = {
      resource: null,
      sourceId: 'nutty-drawer-bridge',
      data: { source: 'nutty-drawer-bridge', itemCount: itemCount }
    };
    nativeDispatch(e);
  }

  function refresh() {
    nativeFetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { properCartUpdate(c && c.item_count); })
      .catch(function () { properCartUpdate(0); });
  }

  document.dispatchEvent = function (evt) {
    if (evt && evt.type === 'cart:update' && (!evt.detail || !evt.detail.data)) {
      refresh();
      return true;
    }
    return nativeDispatch(evt);
  };

  /* ---------- 3. gumb koji stare skripte traze ---------- */

  function tagTrigger() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;
    var btn = drawer.querySelector('button');
    if (btn && !btn.hasAttribute('data-cart-drawer-toggle')) {
      btn.setAttribute('data-cart-drawer-toggle', '');
    }
  }

  function boot() {
    tagTrigger();
    try {
      new MutationObserver(tagTrigger).observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
